import naja from 'naja'

import singleSubmit from './singleSubmit'
import '../../sass/empty.sass'

class WeseusFormExtension {
	constructor(naja) {
		naja.addEventListener('init', () => {
			this.registerListener(document);
			this.registerWheelListener();
			singleSubmit(document);
		});
		naja.snippetHandler.addEventListener('afterUpdate', (e) => {
			this.registerListener(e.snippet);
		});
	}

	registerListener(block) {
		let elements = block.querySelectorAll('[data-change-link]');
		elements.forEach((element) => {
			if (element.hasAttribute('data-change-link')) {
				element.addEventListener('change', (e) => {
					let link = element.getAttribute('data-change-link')
					if (link.includes('__value__')) {
						if (!element.value) {
							return;
						}

						let value = element.value;
						if (element.type === 'select') {
							value = element.options[element.selectedIndex].value;
						}

						link = link.replace('__value__', value);
					}

					naja.makeRequest('GET', link);
				});
			}
		});

		elements = block.querySelectorAll('[data-change-submit]');
		elements.forEach((element) => {
			element.addEventListener('change', (e) => {
				const submit = element.getAttribute('data-change-submit');
				if (submit !== '' && submit !== null) {
					element.form.querySelector(`button[name='${submit}']`).click();
				} else {
					element.form.submit();
				}
			});
		});
	}

	registerWheelListener() {
		document.addEventListener("wheel", function(event) {
			if (document.activeElement.type === "number" && document.activeElement.hasAttribute("ws-noscroll")) {
				document.activeElement.blur();
			}
		});
	}
}

naja.registerExtension(WeseusFormExtension);